import React, { useState } from 'react';
import { Send, Wallet, Upload } from 'lucide-react';
import { Button } from '../SubscriptionAppButton';
import { Card, Toggle, FieldLabel } from './walletUi';
import { walletKpis } from '../../data/mockDigitalWallet';
export function WalletSettingsTab({
  onToast,
  onTurnOff
}: {
  onToast: (msg: string) => void;
  onTurnOff: () => void;
}) {
  const [issueMode, setIssueMode] = useState<'auto' | 'request'>('auto');
  const [brandDownload, setBrandDownload] = useState(true);
  const [confirm, setConfirm] = useState<null | 'issue' | 'resend' | 'off'>(null);
  const notIssued = 0;
  const notAdded = walletKpis.issued - walletKpis.inWallet;
  return <div className="space-y-6 max-w-3xl" data-id="element-2882" data-mp="3aiiyn7wqw8k5">
      <Card title="Digital wallet" description="Billed with your WinePik plan, based on active loyalty members." data-id="element-2883" data-mp="35kr5kakd6ged">
        <div className="flex items-center justify-between" data-id="element-2884" data-mp="ptcze4y7yz2b">
          <div className="flex items-center gap-3" data-id="element-2885" data-mp="kvtkr3xm0k9u">
            <div className="w-10 h-10 rounded-full bg-[#D1FAE5] flex items-center justify-center" data-id="element-2886" data-mp="kvbjfsw3bfv2">
              <Wallet className="w-5 h-5 text-[#059669]" data-id="element-2887" data-mp="3cvp6g80hka2f" />
            </div>
            <div data-id="element-2888" data-mp="3htqnknecpzb9">
              <div className="text-sm font-semibold text-[#0F172A]" data-id="element-2889" data-mp="3ht74h3cyt4vn">On</div>
              <div className="text-xs text-[#64748B]" data-id="element-2890" data-mp="3mv65w7p59rpy">
                {walletKpis.loyaltyMembers.toLocaleString()} active loyalty members · 1,001 to 5,000 band · $49 USD a month
              </div>
            </div>
          </div>
          <Button variant="secondary" size="sm" onClick={() => setConfirm('off')} data-id="element-2891" data-mp="2u3cseo0gzkcg">
            Turn off
          </Button>
        </div>
      </Card>

      <Card title="Who gets a pass" data-id="element-2892" data-mp="343dfml1gmklx">
        <div className="space-y-3" data-id="element-2893" data-mp="34229iekjl0rn">
          {([['auto', 'Every loyalty member, automatically', 'A pass is created when someone joins loyalty, and the link goes out in your welcome email.'], ['request', 'Only members who ask for one', 'Members add the pass from the member portal or the link in your emails.']] as const).map(([v, l, h]) => <label key={v} className={`flex items-start gap-3 p-3 border rounded-lg cursor-pointer ${issueMode === v ? 'border-[#0EA5E9] bg-[#F0F9FF]' : 'border-[#E2E8F0]'}`} data-id="element-2894" data-mp="28dd57nxf3gq5">
              <input type="radio" name="issueMode" checked={issueMode === v} onChange={() => {
            setIssueMode(v);
            onToast('Setting saved');
          }} className="mt-1 text-[#0EA5E9] focus:ring-[#0EA5E9]" data-id="element-2895" data-mp="23c7a5jgabhdg" />
              <div data-id="element-2896" data-mp="1pe8xqjlixv0l">
                <div className="text-sm font-medium text-[#0F172A]" data-id="element-2897" data-mp="1pdpff1ryp4m1">{l}</div>
                <div className="text-xs text-[#64748B]" data-id="element-2898" data-mp="1kfnvkempp19i">{h}</div>
              </div>
            </label>)}
        </div>
        <p className="text-xs text-[#94A3B8] mt-3 m-0" data-id="element-2899" data-mp="1zd7zdi7vgqe3">
          The pass link is added to your Klaviyo welcome flow as a property, so you control the email.
        </p>
      </Card>

      <Card title="Existing members" description="For members who joined before the wallet was switched on, or haven't added their pass yet." data-id="element-2900" data-mp="3arlfu20aq3k3">
        <div className="space-y-3" data-id="element-2901" data-mp="35rz642jof5g1">
          <div className="flex items-center justify-between p-3 border border-[#E2E8F0] rounded-lg" data-id="element-2902" data-mp="35v3cn6km6d9v">
            <div data-id="element-2903" data-mp="3demcsplzon5o">
              <div className="text-sm font-medium text-[#0F172A]" data-id="element-2904" data-mp="3ib30xjt6v1ir">Issue passes to existing members</div>
              <div className="text-xs text-[#64748B]" data-id="element-2905" data-mp="34c3dgfhewso6">{notIssued === 0 ? 'Every loyalty member already has a pass.' : `${notIssued} members without a pass`}</div>
            </div>
            <Button variant="secondary" size="sm" disabled={notIssued === 0} onClick={() => setConfirm('issue')} data-id="element-2906" data-mp="3w2rd1n3ftpzq">
              Issue passes
            </Button>
          </div>
          <div className="flex items-center justify-between p-3 border border-[#E2E8F0] rounded-lg" data-id="element-2907" data-mp="4ykkynb6oefj">
            <div data-id="element-2908" data-mp="3n8d0hsaaktkb">
              <div className="text-sm font-medium text-[#0F172A]" data-id="element-2909" data-mp="3rc182ayxbp5k">Resend the pass link</div>
              <div className="text-xs text-[#64748B]" data-id="element-2910" data-mp="3r9olfki80qm6">{notAdded.toLocaleString()} members have a pass but haven't added it to a wallet</div>
            </div>
            <Button variant="secondary" size="sm" iconLeft={<Send className="w-4 h-4" data-id="element-2912" data-mp="2w40pigl8hezx" />} onClick={() => setConfirm('resend')} data-id="element-2911" data-mp="nnr7klf3lq6m">
              Resend link
            </Button>
          </div>
        </div>
      </Card>

      <Card title="Download page" description="The page members land on to add the pass to their phone." data-id="element-2913" data-mp="2r3mcsl8otgvk">
        <div className="flex items-center justify-between mb-4" data-id="element-2914" data-mp="2m7xaia5a9lvk">
          <div data-id="element-2915" data-mp="2i5anqnngyr58">
            <div className="text-sm text-[#0F172A]" data-id="element-2916" data-mp="2i5ty9jasid98">Match my pass design</div>
            <div className="text-xs text-[#64748B]" data-id="element-2917" data-mp="3etgqt64qtbhe">Uses your logo and the Enthusiast tier colours.</div>
          </div>
          <Toggle on={brandDownload} onChange={v => {
          setBrandDownload(v);
          onToast('Setting saved');
        }} label="Match my pass design" data-id="element-2918" data-mp="39vypo1wyw0jy" />
        </div>
        {!brandDownload && <div data-id="element-2919" data-mp="312lokcor1sms">
            <FieldLabel data-id="element-2920" data-mp="3110ueo6ckbpg">Background image</FieldLabel>
            <Button variant="secondary" size="sm" iconLeft={<Upload className="w-4 h-4" data-id="element-2922" data-mp="1hq3pcoya80r" />} data-id="element-2921" data-mp="1fvgfrq7i3ti">
              Upload image
            </Button>
          </div>}
        <div className="mt-4 border border-[#E2E8F0] rounded-lg p-6 bg-[#1F2937] text-center" data-id="element-2923" data-mp="3ssgeaagirkbz">
          <div className="text-white text-sm font-semibold mb-1" data-id="element-2924" data-mp="1fdq57vydd7st">Acme Estate</div>
          <div className="text-[#CBD5E1] text-xs mb-4" data-id="element-2925" data-mp="1kb00hs8fwdok">Add your member pass to your phone</div>
          <div className="flex justify-center gap-2" data-id="element-2926" data-mp="1oas2fm3bvlky">
            <span className="px-3 py-1.5 bg-black text-white text-xs rounded-md border border-white/20" data-id="element-2927" data-mp="1tbxv5jwzn8uh">Add to Apple Wallet</span>
            <span className="px-3 py-1.5 bg-black text-white text-xs rounded-md border border-white/20" data-id="element-2928" data-mp="1y9pwf4jiw7bc">Add to Google Wallet</span>
          </div>
        </div>
      </Card>

      {confirm && <>
          <div className="fixed inset-0 bg-black/50 z-[60]" onClick={() => setConfirm(null)} data-id="element-2929" data-mp="281lw2k19c5ho" />
          <div className="fixed inset-0 z-[60] flex items-center justify-center p-4 pointer-events-none" data-id="element-2930" data-mp="2c0uptowas3d8">
            <div className="bg-white rounded-lg shadow-xl w-[440px] p-6 pointer-events-auto" data-id="element-2931" data-mp="2h2bn7afkp7p2">
              <h3 className="text-base font-semibold text-[#0F172A] mb-2" data-id="element-2932" data-mp="2m0vd1lxaf3mp">
                {confirm === 'resend' ? `Resend the pass link to ${notAdded} members?` : confirm === 'issue' ? 'Issue passes to existing members?' : 'Turn off the digital wallet?'}
              </h3>
              <p className="text-sm text-[#475569] mb-5" data-id="element-2933" data-mp="vo5nh8dpr30q">
                {confirm === 'resend' ? 'They get an email with the link to add their pass. Members who already added it are skipped.' : confirm === 'issue' ? 'A pass is created for every loyalty member without one.' : 'Billing stops at the end of your current cycle. Members\' passes stop updating and are marked as no longer active.'}
              </p>
              <div className="flex justify-end gap-2" data-id="element-2934" data-mp="1elgjmk41tgby">
                <Button variant="ghost" size="sm" onClick={() => setConfirm(null)} data-id="element-2935" data-mp="1ek5didn4rwho">
                  Cancel
                </Button>
                <Button variant={confirm === 'off' ? 'danger' : 'primary'} size="sm" onClick={() => {
              const c = confirm;
              setConfirm(null);
              if (c === 'off') onTurnOff();else onToast(c === 'resend' ? `Pass link sent to ${notAdded} members` : 'Passes issued');
            }} data-id="element-2936" data-mp="3gd33m1piwayx">
                  {confirm === 'resend' ? 'Resend link' : confirm === 'issue' ? 'Issue passes' : 'Turn off'}
                </Button>
              </div>
            </div>
          </div>
        </>}
    </div>;
}